import { LocalWhiteboardSettings } from 'features/whiteboard/types';
import { WhiteboardSettingKey, WhiteboardSettings } from 'utils/whiteboard/settings';

export const applyLocalWhiteboardSettings = (
  settings: WhiteboardSettings,
  local: LocalWhiteboardSettings | undefined
): WhiteboardSettings => {
  if (!local) {
    return settings;
  }

  return (Object.keys(local) as WhiteboardSettingKey[]).reduce<WhiteboardSettings>(
    (effective, key) => {
      const pick = local[key];

      // the pick stands only against the synced value it was made over — a board changed
      // while the user was on another one comes back with what everyone else sees
      if (!pick || pick.syncedValue !== settings[key]) {
        return effective;
      }

      return { ...effective, [key]: pick.value };
    },
    settings
  );
};
